import Check from '@/components/header/components/check';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import '@/components/header/components/hints/hints-v1.css';
import '@/components/header/components/hints/hints-v2.css';

export default function Hints() {
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const { info, openingTimes } = useAppSelector(ConfigSlice.selectors.header);

  if (!info && !openingTimes) return null;

  return (
    <div data-css-version={cssVersion} className='header-hints'>
      {info ? <Check text={info} /> : null}
      {openingTimes ? <Check text={openingTimes} /> : null}
    </div>
  );
}
